import React, { FC } from 'react';

import { AnnouncementBanner } from 'src/apps/mobile-sdk/components/announcement-banner/AnnouncementBanner';
import { MobileSdkRouter } from 'src/apps/mobile-sdk/router/MobileSdkRouter';
import { useMobileSdkBannerStore } from 'src/apps/mobile-sdk/stores/mobileSdkBannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import CloseIcon from 'src/common/components/icons/CloseIcon.svg?raw';

import './MobileSdkWrapper.scss';

type MobileSdkWrapperProps = Record<string, never>;

export const MobileSdkWrapper: FC<MobileSdkWrapperProps> = () => {
	const { visible: isBannerVisible, setVisible } = useMobileSdkBannerStore();

	return (
		<div className="mobile-sdk-wrapper">
			{isBannerVisible && (
				<div className="clarification-banner-wrapper">
					<ClarificationBanner
						hide={() => setVisible(false)}
						dismissIcon={CloseIcon}
						showToggle={false}
					>
						<AnnouncementBanner />
					</ClarificationBanner>
				</div>
			)}
			<div className="mobile-sdk-content">
				<MobileSdkRouter />
			</div>
		</div>
	);
};
